import Img from "../../../../content/components/tutorial-image";
import * as React from 'react';
export default {
  Img,
  React
};